import 'regenerator-runtime/runtime';
import 'details-element-polyfill';
import 'app/common/polyfills/array-includes';
import 'app/common/polyfills/string-includes';
import 'app/common/polyfills/object-assign';
import 'app/common/polyfills/fetch-headers';
